import React from "react";

const NoItemFound = ({ msg }) => {
  return (
    <div className="my-10 bg-front dark:dark-bg-front text-center text-lg  md:w-1/2 md:mx-auto mx-10 py-40 text-brand  block col-span-full ">
      <h1 className="text-4xl">{msg}</h1>
    </div>
  );
};

export default NoItemFound;
